import getConfig from 'next/config';

export const B2bFavicons = () => {
    const { publicRuntimeConfig } = getConfig();
    const cdnUrl = publicRuntimeConfig.cdnUrl;
    const faviconsBaseUrl = `${cdnUrl}/favicons/b2b`;

    return (
        <>
            <link
                key="b2b-safari-pinned-tab"
                color="#D90000"
                href={`${faviconsBaseUrl}/safari-pinned-tab.svg`}
                rel="mask-icon"
            />
            <link
                key="b2b-favicon-ico"
                href={`${faviconsBaseUrl}/favicon.ico`}
                rel="shortcut icon"
                type="image/x-icon"
            />
            <link
                key="b2b-apple-touch-icon"
                href={`${faviconsBaseUrl}/apple-touch-icon.png`}
                rel="apple-touch-icon-precomposed"
                sizes="180x180"
            />
            <link
                key="b2b-android-chrome-192x192"
                href={`${faviconsBaseUrl}/android-chrome-192x192.png`}
                rel="icon"
                sizes="192x192"
                type="image/png"
            />
            <link
                key="b2b-android-chrome-512x512"
                href={`${faviconsBaseUrl}/android-chrome-512x512.png`}
                rel="icon"
                sizes="512x512"
                type="image/png"
            />
            <link
                key="b2b-favicon-32x32"
                href={`${faviconsBaseUrl}/favicon-32x32.png`}
                rel="icon"
                sizes="32x32"
                type="image/png"
            />
            <link
                key="b2b-favicon-16x16"
                href={`${faviconsBaseUrl}/favicon-16x16.png`}
                rel="icon"
                sizes="16x16"
                type="image/png"
            />
            <link key="b2b-site-webmanifest" href={`${faviconsBaseUrl}/site.webmanifest`} rel="manifest" />
            <meta
                key="b2b-browserconfig"
                content={`${faviconsBaseUrl}/browserconfig.xml`}
                name="msapplication-config"
            />
            <link
                key="b2b-mstile-150x150"
                href={`${faviconsBaseUrl}/mstile-150x150.png`}
                rel="icon"
                sizes="150x150"
                type="image/x-icon"
            />
        </>
    );
};
